define('plugin/line-liff/step/LineLiffClientLoginStep',['require','lib/controller/booking/BaseStep','plugin/line-liff/view/LineLiffClientLoginStepView'],function (require) {

    var BaseStep = require('lib/controller/booking/BaseStep');
    var LineLiffClientLoginStepView = require('plugin/line-liff/view/LineLiffClientLoginStepView');
   // var ClientSignInModel = require('plugin/client-login/model/ClientSignInModel');

    return BaseStep.extend({

        _step: 'line_liff',
        _clientModel: null,
        _signInModel: null,
        _skipStepManual: false,
        _handler: null,

        /**
         * Initialize models and subscribe to events
         */
        initialize: function () {
            BaseStep.prototype.initialize.apply(this);

            this._clientModel = this.getOption('clientModel');
            //this._signInModel = this.getOption('signInModel');
            this._handler = this.getOption('handler');

            this._skipStepManual = false;
            this.setIsSkipped(true);
        },

        /**
         * Returns step view
         *
         * @return LineLiffClientLoginStepView
         */
        getView: function () {
            var view = new LineLiffClientLoginStepView({
                clientModel: this._clientModel,
                //signInModel: this._signInModel,
                termsModel: this._handler.getTermsController().getModel()
            });

            this.listenTo(view, 'signIn', _.bind(function (data) {
                this._handler.performSignIn(data.view.getDataToSignIn());
            }, this));
            //
            this.listenTo(view, 'skipStep', _.bind(function (data) {
                this._handler.skipStep();
            }, this));
            //
            this.listenTo(view, 'dom:refresh', _.bind(function () {
                view.showTermsAndConditions(this._handler.getTermsController().getView());
            }, this));
            //
            this.listenTo(view, 'clientLogged', this.done);
            // this.listenTo(view, 'clientLoggedOut', this.done);

            return view;
        },


        skipStep: function () {
            this._skipStepManual = true;
            this.done();
        },

        /**
         * Returns true if user has been logged in
         *
         * @return Boolean
         */
        isValid: function () {
            if(this._skipStepManual) {
                return true;
            }
            if (this._clientModel.get('is_logged_in') && this._clientModel.get('id')) {
                return true;
            }
            return false;
        },
        
        getClientModel: function () {
            return this._clientModel;
        }

    });

});
